import { connect } from "react-redux";
import React, { useEffect } from "react";
import { Box, CircularProgress } from "@material-ui/core";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";

import { getFilteredOtherWork } from "../../../reducer/otherWork/action";
import dayjs from "dayjs";

function ListOtherWork(props) {
  useEffect(() => {
    props.getFilteredOtherWork(1, -1, {
      // accepted: true,
      dashboardYear: props.chosenYear,
      departmentId: props.chosenDepartmentId,
      acceptedOne: true,
    });
  }, [props.chosenYear]);

  const getOtherWorkType = (type) => {
    switch (type) {
      case "consulting_with_contract":
        return "Hoạt động Tư vấn doanh nghiệp";
      default:
        return "";
    }
  };

  const getOtherWorkTitle = (info, index) => {
    return (
      <div key={`otherWork-${index}`} style={{ marginTop: 16 }}>
        <div>
          <b style={{ color: "gray" }}>
            {index + 1}. Tên {getOtherWorkType(info.otherWork.type)}:{" "}
          </b>
          <i style={{ color: "red" }}> {info.otherWork.title}</i>
        </div>
        <div style={{ marginLeft: 20 }}>
          <b>- Mã quản lý: </b>
          {info.otherWork.code || ""}
          <br />
          <b>- Thời gian thực hiện: </b>
          {dayjs(info.otherWork.workingTime).format("DD/MM/YYYY")}
          <br />
        </div>
      </div>
    );
  };

  return props.isFetching ? (
    <div style={{ textAlign: "center" }}>
      <CircularProgress />
    </div>
  ) : (
    <Box paddingRight={1} height="calc(100vh - 214px)" minWidth="calc(100% + 8px)" style={{ overflowY: "auto" }}>
      {props.listOtherWorkAccepted.map((item, index) => getOtherWorkTitle(item, index))}
    </Box>
  );
}

const mapStateToProps = (state) => ({
  listOtherWorkAccepted: select(state, "otherWorkReducer", "listFiltered"),
  isFetching: select(state, "otherWorkReducer", "isFetching"),
});

const mapDispatchToProps = (dispatch) => ({
  getFilteredOtherWork: (page, pageSize, payload) => dispatch(getFilteredOtherWork(page, pageSize, payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(ListOtherWork));

